import React, { ReactNode } from "react";

import AppBox from "@/components/AppBox"
import AppText from "@/components/AppText"

interface AppPageContainerProps {
  children: ReactNode; // Defines the type for the children prop
  title: string; // The title is a required string
  titleAdorment?: ReactNode; // Optional ReactNode for any additional content in the title section
}

const AppPageContainer: React.FC<AppPageContainerProps> = ({ children, title, titleAdorment }) => {

  return (
    <AppBox fullWidth column gap={2}>
      <AppBox justify="between" align="center" gap={2} className="min-h-[38px]">
        <AppText variant="h3">{ title }</AppText>
        {titleAdorment ? titleAdorment : null}
      </AppBox>

      { children }
    </AppBox>
  );
};

export default AppPageContainer;